import * as AppTypes from "AppTypes";
import { actionTypes } from "../actions/";
import { IAddressResponse } from "../utils/api";
import { IEntryDocuments, ICaptcha } from "../types/appDataTypes";

export type TSteps =
  | "Verify"
  | "ActiveCountry"
  | "BasicInfo"
  | "AddressInfo"
  | "WorkStatus"
  | "ParentInfo"
  | "ArtistStatus"
  | "Dashboard"
  | "EntryEditor"
  | "Declaration"
  | "Complete"
  | "Error"
  | "ServiceError"
  | "UnsupportedBrowser";

export interface IErrorState {
  title?: string;
  content?: string;
  button?: {
    text: string;
    onClick: () => void;
  };
}

export interface IEntryViewState {
  entryIndex?: number;
}

interface IAppState {
  step: TSteps;
  messages: any[];
  isCallingApi: boolean;
  viewState: IErrorState | IEntryViewState;
  retrievedAddress: IAddressResponse;

  pictureStore: {
    [key: string]: IEntryDocuments;
  };
  isAppUpdated: boolean;
  errorRetryCount: number;
  verifyCaptcha: ICaptcha
}

export const initiaCaptcha: ICaptcha = {
  reCaptchaKey: "",
  isReCaptchaVerified: false
}

export const initialState: IAppState = {
  step: "BasicInfo",
  messages: [],
  isCallingApi: false,
  viewState: {},
  retrievedAddress: null,
  pictureStore: {},
  isAppUpdated: false,
  errorRetryCount: 0,
  verifyCaptcha: initiaCaptcha
};



let persistStore = JSON.parse(
  window.sessionStorage.getItem("application-store")
);
let persistApp = persistStore && persistStore.app;
if (/verify=/.test(window.location.search)) {
  persistStore = undefined;
  persistApp = undefined;
}

export const appReducer = (
  state: IAppState = persistApp || initialState,
  action: AppTypes.RootAction
) => {
  switch (action.type) {
    case actionTypes.GOTO_STEP:
      return {
        ...state,
        step: action.payload.step,
        viewState: action.payload.state,
      };

    case actionTypes.ADD_MESSAGE:
      return {
        ...state,
        messages: state.messages.length
          ? [...state.messages, action.payload]
          : [action.payload],
      };

    case actionTypes.POP_MESSAGE:
      return {
        ...state,
        messages: state.messages.length > 1 ? state.messages.shift() : [],
      };

    case actionTypes.SET_IS_CALLING_API:
      return { ...state, isCallingApi: action.payload };

    case actionTypes.SET_APPLICATION_UPDATED:
      return { ...state, isAppUpdated: action.payload };

    case actionTypes.UPDATE_RETRIEVED_ADDRESS:
      return { ...state, retrievedAddress: action.payload };

    case actionTypes.UPDATE_ENTRY_DOCUMENTS:
      return {
        ...state,
        pictureStore: {
          ...state.pictureStore,
          [action.payload.entryId]: action.payload.documents,
        },
      };

    case actionTypes.UPDATE_ENTRY_SINGLE_DOCUMENT:
      return {
        ...state,
        pictureStore: {
          ...state.pictureStore,
          [action.payload.entryId]: {
            p1: "",
            s1: "",
            s2: "",
            ...state.pictureStore[action.payload.entryId],
            [action.payload.documentId]: action.payload.value,
          },
        },
      };

    case actionTypes.UPDATE_ERROR_RETRY_COUNT:
      return {
        ...state,
        errorRetryCount: action.payload,
      };
    case actionTypes.UPDATE_RECAPTCHA_VERIFIED:
      return {
        ...state,
        verifyCaptcha: action.payload
      }

    default:
      return state;
  }
};
